import { LoginForm } from './types';

export const EMPTY_EMAIL_WARNING = 'Please enter your email address';
export const INCORRECT_EMAIL_WARNING = 'Please enter correct email address';
export const EMPTY_PASSWORD_WARNING = 'Please enter your password';
export const EMPTY_VALIDATION_CODE_WARNING = 'Please enter validation code';
export const MFA_EMAIL_TOAST_TEXT = 'Verification code was sent to your email';
export const MFA_VIRTUAL_TOAST_TEXT = 'Enter the code from your 2FA authenticator app';

export const initialFormState: LoginForm = {
  email: {
    value: '',
    error: null,
  },
  password: {
    value: '',
    error: null,
  },
  mfaCode: {
    value: '',
    error: null,
  },
};
